import FinalWarehouseCheck from './FinalWarehouseCheck';
import { withI18n } from 'react-i18next';

export default withI18n()(FinalWarehouseCheck);
